import { useStore } from '@/utils/useStore'
import UserStore from '@/store/user'
import { conversationArchiveAPI, conversationLeaveAPI, conversationMessageRemoveAPI, conversationJoinAPI, conversationConsentAPI, conversationUsersGetAPI, conversationReadAPI } from '@/api/conversations'

export default defineStore('conversations', () => {
  const { getItem, getItems, setItem, deleteItem } = useStore('conversation')

  const users = async (userIds: string[]) => {
    const response = await conversationUsersGetAPI(userIds)

    if (response.ok && response.data.conversation) {
      const createdItem = response.data.conversation
      setItem(createdItem)

      return createdItem
    }

    return null
  }

  const leave = async (conversationId: string) => {
    const response = await conversationLeaveAPI(conversationId)

    if (response.ok) {
      const createdItem = response.data.conversation
      setItem(createdItem)
    }

    return { ok: true }
  }

  const archive = async (
    conversationId: string,
    action: 'archive' | 'unarchive',
    userId: string
  ) => {
    const conversation = getItem(conversationId)
    
    if (conversation) setItem({
      ...conversation,
      archivedBy: action === 'archive' ? [ userId ] : []
    })

    if (action === 'archive') {
      const route = useRoute()
      
      useNuxtApp().$amplitude.logEvent(`Convo_Archive`, {
        source: route.fullPath
      })
    }

    const response = await conversationArchiveAPI(conversationId, action)
    if (response.ok) setItem(response.data.conversation)

    return { ok: true }
  }

  const read = async (
    conversationId: string,
    userId: string
  ) => {
    const conversation = getItem(conversationId)
    
    if (conversation) setItem({
      ...conversation,
      readBy: [ ...conversation.readBy, userId ]
    })

    const response = await conversationReadAPI(conversationId)
    if (response.ok) setItem(response.data.conversation)

    return { ok: true }
  }

  const join = async (conversationId: string) => {
    const conversation = getItem(conversationId)

    const userStore = UserStore()
    const { currentUser } = storeToRefs(userStore)

    if (!conversation?.isParticipant(currentUser.value?._id)) {
      const response = await conversationJoinAPI(conversationId)

      if (response.ok) {
        const createdItem = response.data.conversation
        setItem(createdItem)
      }
    }

    return { ok: true }
  }

  const consent = async (conversationId: string) => {
    const response = await conversationConsentAPI(conversationId)

    if (response.ok) {
      const createdItem = response.data.conversation
      setItem(createdItem)
    }

    return { ok: true }
  }

  const removeMessage = async (messageId: string) => {
    return await conversationMessageRemoveAPI(messageId)
  }

  return {
    setItem, deleteItem, removeMessage, join, users, read,
    getItems, getItem, fetch, archive, leave, consent
  }
})